import { render, staticRenderFns } from "./VFirstLoginRefundGuidePopUp.vue?vue&type=template&id=274cd0cc&scoped=true&"
import script from "./VFirstLoginRefundGuidePopUp.vue?vue&type=script&lang=js&"
export * from "./VFirstLoginRefundGuidePopUp.vue?vue&type=script&lang=js&"
import style0 from "./VFirstLoginRefundGuidePopUp.vue?vue&type=style&index=0&id=274cd0cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274cd0cc",
  null
  
)

export default component.exports